module.exports = __webpack_public_path__ + "img/v5.78a999d.png";